import { createContext, useContext } from 'react';

export type PollResultsData = {
  poll: {
    question: string;
    poll_type: string;
    poll_style: string;
    trivia_answer?: string;
    live_results_enabled?: boolean;
    redirect_url?: string;
  };
  poll_choices: Array<{ id: string; label: string }>;
  metrics: Array<{ label: string; percentage: string }>;
  fallback_redirect_url?: string;
};

export type PollInteractionContextType = {
  submitVote: (params: {
    pollId: string;
    pollChoiceId: string;
    postPollId: string;
    subscriberId: string;
  }) => Promise<PollResultsData | null>;
};

export const PollInteractionContext = createContext<PollInteractionContextType | null>(null);

export const usePollInteraction = () => useContext(PollInteractionContext);
